import { z } from "zod";
import { NpdCalculationState } from "../npd-calculation-state";
import { npdCalculationErrorsDtoSchema } from "./npd-calculation-errors.schema";
import { npdCalculationResultsDtoSchema } from "./npd-calculation-results.schema";
export const npdFailedCalculationStatusDtoSchema = z.object({
    state: z.literal(NpdCalculationState.Failed),
    errors: npdCalculationErrorsDtoSchema,
    partialResults: npdCalculationResultsDtoSchema,
});
